import { mq } from './Layout.styles'
import styled from '@emotion/styled'
import Atom from './Atom.styles'

/* Default sizes change if you need */
export const StyledH5 = styled(Atom)(props => (
  mq({
    fontWeight: [600],
    letterSpacing: ['normal'],
    lineHeight: ['normal']
  })
))
